import { TenantIsActiveDeltaRequest  , TenantIsActiveResponse, TicketConfigClient } from 'services/tenantManagementService';
import { getTenantId } from 'features/Tenant/tenantUtils';
import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import store from 'base/reducer/store';
import { tryCatchJsonByAction } from 'utils/fetchUtils';

export const getTicketClosingIdsAction = () => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.getTicketClosingIds(tenantId);
}

export const updateTicketClosingIdsAction = (ticketClosingIdsDelta: TenantIsActiveDeltaRequest) => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.updateTicketClosingIds(tenantId, ticketClosingIdsDelta);
}

export const persistTicketClosingIdAction = async () => {
	const state = store.getState();

	if (state.persistedTicketClosingId.fetching) {
		return;
	}

	store.dispatch(setFetchingAction(true));

	const response = await tryCatchJsonByAction(getTicketClosingIdsAction);
	if (response.success) {
		store.dispatch(setAction(response.items || []));
	} else {
		store.dispatch(setFetchingAction(false));
	}
}

// redux

export const TICKET_CLOSING_ID_FETCHING = 'TICKET_CLOSING_ID_FETCHING';
export const TICKET_CLOSING_ID_SET = 'TICKET_CLOSING_ID_SET';

const setFetchingAction = (fetching: boolean): FetchingActionType => {
	return {
		type: TICKET_CLOSING_ID_FETCHING,
		fetching
	}
}

const setAction = (items: TenantIsActiveResponse[]): PersistItemsActionType<TenantIsActiveResponse> =>  {
	return {
		type: TICKET_CLOSING_ID_SET,
		items
	}
}
